import { LayoutConfig } from '@cadriciel/core';
import packageJson from '../../package.json';

/**
 * Application Layout Configuration (Abstract)
 *
 * This is the single source of truth for layout configuration.
 * Each layout component reads these values and interprets them
 * according to its own implementation.
 *
 * To switch layouts, change the layout component in app.routes.ts
 * The config stays the same - layouts adapt to it.
 */
export const APP_LAYOUT_CONFIG = {
    // Theme
    preset: 'Aura',
    primary: 'blue',
    surface: null,
    darkTheme: false,
    layoutTheme: 'primaryColor',

    // Menu
    menuMode: 'static',

    // Branding
    logoUrl: 'assets/logo.png',
    logoAlt: 'Cerema Logo',
    appName: (packageJson as any).title || (packageJson as any).name,
    appVersion: (packageJson as any).version,

    // UI Elements visibility
    showBreadcrumb: false,
    showFooter: false,
    showSearch: false,
    showSettings: false,

    // Toolbar configuration
    toolbarConfig: {
        leftItems: [],
        rightItems: [
            {
                icon: 'pi pi-user',
                label: 'Profile',
                items: [
                    {
                        label: 'Settings',
                        icon: 'pi pi-cog',
                        routerLink: ['/settings']
                    },
                    {
                        label: 'Logout',
                        icon: 'pi pi-sign-out'
                    }
                ]
            }
        ]
    }
};
